import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";

const AdmissionSuspension = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">
                  Admission Suspension
                </h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/admissionsuspension">Admission Suspension</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-admission-suspension section-1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-12">
              <div className="admission-suspension-content">
                <h3 className="admission-suspension-cont-title">
                  Admission cancellation rules
                </h3>
                <p className="admission-suspension-cont-text">
                  Many desktop publishing packages and web page editors now use
                  Lorem Ipsum as their default model text, and a search for
                  'lorem ipsum' will uncover many web sites still in their
                  infancy. Various versions have evolved over the years,
                  sometimes by accident, sometimes on purpose (injected humour
                  and the like).
                </p>
                <ul className="admission-suspension-cont-list">
                  <li>
                    <span>01</span>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form.
                  </li>
                  <li>
                    <span>02</span>
                    If you are going to use a passage of Lorem Ipsum, you need
                    to be sure there isn't anything embarrassing hidden.
                  </li>
                  <li>
                    <span>03</span>
                    But I must explain to you how all this mistaken idea of
                    denouncing pleasure and praising pain.
                  </li>
                  <li>
                    <span>04</span>
                    Et harum quidem rerum facilis est et expedita distinctio.
                    Nam libero tempore, cum soluta nobis est eligendi optio
                    cumque nihil impedit.
                  </li>
                  <li>
                    <span>05</span>
                    On the other hand, we denounce with righteous indignation
                    and dislike men.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6  col-12">
              <div className="admission-suspension-img">
                <img src="https://via.placeholder.com/656x520" alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-admission-suspension section-2">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-12">
              <div className="admission-suspension-img">
                <img src="https://via.placeholder.com/656x520" alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="admission-suspension-content">
                <h3 className="admission-suspension-cont-title">
                  The rules of school suspension
                </h3>
                <p className="admission-suspension-cont-text">
                  Many desktop publishing packages and web page editors now use
                  Lorem Ipsum as their default model text, and a search for
                  'lorem ipsum' will uncover many web sites still in their
                  infancy. Various versions have evolved over the years,
                  sometimes by accident, sometimes on purpose (injected humour
                  and the like).
                </p>
                <ul className="admission-suspension-cont-list">
                  <li>
                    <span>01</span>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form.
                  </li>
                  <li>
                    <span>02</span>
                    If you are going to use a passage of Lorem Ipsum, you need
                    to be sure there isn't anything embarrassing hidden.
                  </li>
                  <li>
                    <span>03</span>
                    But I must explain to you how all this mistaken idea of
                    denouncing pleasure and praising pain.
                  </li>
                  <li>
                    <span>04</span>
                    Et harum quidem rerum facilis est et expedita distinctio.
                    Nam libero tempore, cum soluta nobis est eligendi optio
                    cumque nihil impedit.
                  </li>
                  <li>
                    <span>05</span>
                    On the other hand, we denounce with righteous indignation
                    and dislike men.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-other-rules">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-other-rules-head">
                <h3 className="eschool-other-rules-head-title">
                  Other rules regulation
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 co-12">
              <div className="other-rules-content">
                <ul className="other-rules-content-list">
                  <li>
                    <span>01</span>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form.
                  </li>

                  <li>
                    <span>03</span>
                    But I must explain to you how all this mistaken idea of
                    denouncing pleasure and praising pain. Various versions have
                    evolved over the years.
                  </li>
                  <li>
                    <span>05</span>
                    On the other hand, we denounce with righteous indignation
                    and dislike men.but the majority have suffered alteration.
                  </li>
                  <li>
                    <span>07</span>
                    The generated Lorem Ipsum is therefore always free from
                    repetition, injected humour, or words etc.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 co-12">
              <div className="other-rules-content p-0">
                <ul className="other-rules-content-list">
                  <li>
                    <span>02</span>
                    If you are going to use a passage of Lorem Ipsum, you need
                    to be sure there isn't anything embarrassing hidden.
                  </li>
                  <li>
                    <span>04</span>
                    Et harum quidem rerum facilis est et expedita distinctio.
                    Nam libero tempore, cum soluta nobis est eligendi optio
                    cumque nihil impedit.
                  </li>
                  <li>
                    <span>06</span>
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text. It has roots in a piece of classical Latin literature.
                  </li>
                  <li>
                    <span>08</span>
                    If you are going to use a passage of Lorem Ipsum, you need
                    to be sure there isn't anything embarrassing.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdmissionSuspension;
